export default __webpack_public_path__ + "static/media/child-account-red.9ed99783.svg";